import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { initOAuthReturn } from '@/platform'

/**
 * Route native OAuth deep links (`io.maxflow.app://oauth-callback?...`) into the
 * SPA. Must be mounted inside the Router — the whole point is to land on the
 * callback screen through react-router, inside the authenticated app, rather
 * than through a browser navigation that has no session.
 *
 * No-op on web.
 */
export function useOAuthReturn(): void {
  const navigate = useNavigate()

  useEffect(() => {
    let dispose: (() => void) | undefined
    let cancelled = false

    void initOAuthReturn((route) => navigate(route, { replace: true })).then((remove) => {
      if (cancelled) remove()
      else dispose = remove
    })

    return () => {
      cancelled = true
      dispose?.()
    }
  }, [navigate])
}
